/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechCamPhotoIcon16Light } from './TechCamPhotoIcon16Light';
import { TechCamPhotoIcon16Regular } from './TechCamPhotoIcon16Regular';
import { TechCamPhotoIcon16Solid } from './TechCamPhotoIcon16Solid';
import { TechCamPhotoIcon20Light } from './TechCamPhotoIcon20Light';
import { TechCamPhotoIcon20Regular } from './TechCamPhotoIcon20Regular';
import { TechCamPhotoIcon20Solid } from './TechCamPhotoIcon20Solid';
import { TechCamPhotoIcon24Regular } from './TechCamPhotoIcon24Regular';
import { TechCamPhotoIcon24Solid } from './TechCamPhotoIcon24Solid';
import { TechCamPhotoIcon32Regular } from './TechCamPhotoIcon32Regular';
import { TechCamPhotoIcon64Regular } from './TechCamPhotoIcon64Regular';
var sizes = {
    16: {
        light: TechCamPhotoIcon16Light,
        regular: TechCamPhotoIcon16Regular,
        solid: TechCamPhotoIcon16Solid,
    },
    20: {
        light: TechCamPhotoIcon20Light,
        regular: TechCamPhotoIcon20Regular,
        solid: TechCamPhotoIcon20Solid,
    },
    24: {
        regular: TechCamPhotoIcon24Regular,
        solid: TechCamPhotoIcon24Solid,
    },
    32: {
        regular: TechCamPhotoIcon32Regular,
    },
    64: {
        regular: TechCamPhotoIcon64Regular,
    },
};
export var TechCamPhotoIcon = forwardRef('TechCamPhotoIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
